<template>
  <div class="translate-wrapper">
    <ValidationObserver
      ref="validationObserver"
      v-slot="{ handleSubmit }"
    >
      <form
        class="contact-info"
        novalidate="novalidate"
        @submit.prevent="handleSubmit(submit)"
        @input="handleFormChange"
      >
        <MaterialInput
          v-model="formData.label"
          v-bind="formFields.label"
        />
        <MaterialTextArea
          v-model="formData.description"
          v-bind="formFields.description"
        />
        <div class="poster-title">
          Poster Image (16:9)
        </div>
        <PosterImage
          ref="posterImage"
          :key="formData.posterImages"
          :poster="formData.posterImages"
          :onPosterChange="handlePosterChange"
          :isNeedRemove="true"
        />
        <div class="wrapper-small">
          <div class="poster-title">
            Poster Image (2:3)
          </div>
          <PosterImage
            ref="posterImage2x3"
            :key="formData.posterImage2x3"
            :isPoster2x3="true"
            :poster="formData.posterImage2x3"
            :onPosterChange="handleChangePosterImage2x3"
            :isNeedRemove="true"
            typeOfPerson="small"
            class="poster-2x3-image"
          />
        </div>
        <div class="btn-wrapper">
          <div class="btn-wrapper-b">
            <Button
              type="submit"
              :title="'Apply Changes'"
              :classType="'primary'"
            />
            <Button
              :title="'Revert'"
              :classType="'warning'"
              :eventFunction="revertLanguage"
            />
          </div>
          <div
            v-if="isEditedForm.length
              && isEditedForm.find(item => item.id === lang.id && !!item.value)"
            class="changes-wrapper"
          >
            <inline-svg
              :src="iconChanges"
              class="svg-icon"
            >
            </inline-svg>
            <span class="changes-text">
              Unsaved changes
            </span>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BaseForm from '../BaseForm.vue';
import MaterialInput from '../../inputs/MaterialInput.vue';
import MaterialTextArea from '../../inputs/MaterialTextArea.vue';
import Button from '../../common/Button.vue';
import iconChanges from '../../../assets/icons/icon-localization-changes.svg';
import PosterImage from '../../common/PosterImage/DragAndDropFileUploader.vue';

import {
  ADD_LANGUAGE_ROW_ITEMS_REQUEST,
  GET_LANGUAGE_ROW_ITEMS_REQUEST,
  INIT_FORM_CHANGES,
  SET_FORM_CHANGES,
} from '../../../store/actions/localization/localizationActions';

export default {
  name: 'ManuallyItemForm',
  components: {
    MaterialInput,
    MaterialTextArea,
    PosterImage,
    Button,
  },
  extends: BaseForm,
  props: {
    formPrefix: {
      type: String,
      default: 'cmsManuallyLocalization',
    },
    lang: {
      type: Object,
      default: () => {},
    },
    cmsPage: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
    languages: {
      type: Array,
      default: () => [],
    },
    manuallyItem: {
      type: Object,
      default: () => {},
    },
    changedLanguage: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      iconChanges,
      submitEvent: ADD_LANGUAGE_ROW_ITEMS_REQUEST,
      successMessages: `The ${this.lang.name} Localization has been successfully updated`,
      isPosterSmallChanged: false,
      isPoster2x3Changed: false,
      formData: {
        label: '',
        description: '',
        posterImages: '',
        posterImage2x3: '',
      },
      formFields: {
        label: {
          type: 'text',
          name: 'label',
          formPrefix: this.formPrefix,
          rules: {
            required: false,
            max: 25,
          },
        },
        description: {
          type: 'text',
          name: 'description',
          formPrefix: this.formPrefix,
          rules: {
            min: 1,
            max: 1800,
          },
        },
      },
      errorMapping: {
        label: [
          `${this.formPrefix}.label`,
        ],
      },
    };
  },
  computed: {
    ...mapState({
      isEditedForm: (state) => state.localization.isEditedForm,
      cmsManuallyLanguage: (state) => state.localization.cmsManuallyLanguage,
    }),
    ...mapGetters([
      'getCurrentAccountId',
    ]),
  },
  created() {
    const value = this.languages.map(((item) => ({
      id: item.id,
      value: false,
    })));
    this.$store.dispatch(INIT_FORM_CHANGES, value);

    const params = {
      accountId: this.getCurrentAccountId,
      cmsRowItemsId: this.manuallyItem && this.manuallyItem.id,
      langId: this.lang.id,
    };
    this.$store.dispatch(GET_LANGUAGE_ROW_ITEMS_REQUEST, params).then(() => {
      this.initFormData();
    });
  },
  beforeDestroy() {
    this.$store.dispatch(SET_FORM_CHANGES, []);
  },
  methods: {
    handleFormChange() {
      this.$emit('changedLanguage', { id: this.lang.id, value: true });
    },
    handlePosterChange(img) {
      this.isPosterSmallChanged = true;
      this.handleFormChange();
      this.formData.posterImages = img;
    },
    handleChangePosterImage2x3(img) {
      this.isPoster2x3Changed = true;
      this.handleFormChange();
      this.formData.posterImage2x3 = img;
    },
    initFormData() {
      this.formData.label = this.cmsManuallyLanguage.label;
      this.formData.description = this.cmsManuallyLanguage.description;
      this.formData.posterImages = this.cmsManuallyLanguage.posterImage
        ? `${this.cmsManuallyLanguage.posterImage}?height=360`
        : '';
      this.formData.posterImage2x3 = this.cmsManuallyLanguage.posterImage2x3
        ? `${this.cmsManuallyLanguage.posterImage2x3}?height=360`
        : '';
    },
    revertLanguage() {
      const params = {
        accountId: this.getCurrentAccountId,
        cmsRowItemsId: this.manuallyItem && this.manuallyItem.id,
        langId: this.lang.id,
      };
      this.$store.dispatch(GET_LANGUAGE_ROW_ITEMS_REQUEST, params).then(() => {
        this.$emit('changedLanguage', { id: this.lang.id, value: false });
        this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
        this.isPosterSmallChanged = false;
        this.isPoster2x3Changed = false;
        this.initFormData();
      });
    },
    getRequestData() {
      const data = {
        label: this.formData.label,
        description: this.formData.description,
        posterImage: this.formData.posterImages,
      };

      if (!this.isPosterSmallChanged) {
        delete data.posterImage;
      }

      if (this.isPoster2x3Changed) {
        data.posterImage2x3 = this.formData.posterImage2x3;
      }

      return {
        accountId: this.getCurrentAccountId,
        cmsRowItemsId: this.manuallyItem && this.manuallyItem.id,
        langId: this.lang.id,
        data,
      };
    },
    onSubmitSuccess() {
      this.isPosterSmallChanged = false;
      this.isPoster2x3Changed = false;
      this.$emit('changedLanguage', { id: this.lang.id, value: false });
      this.$store.dispatch(SET_FORM_CHANGES, { id: this.lang.id, value: false });
      this.$toasted.global.success({
        message: this.successMessages,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.translate-wrapper {
}

.poster-title {
  color: #fff;
  font-weight: normal;
  margin-bottom: 10px;
}

.btn-wrapper {
  display: flex;
  flex-wrap: wrap;
  padding-top: 35px;
}

.wrapper-small {
  margin-top: 20px;
}

.poster-2x3-image{
  height: 400px;
}

.changes-wrapper {
  display: flex;
  align-items: center;
  border: 1px solid #FB3951;
  border-radius: 2px;
  padding: 8px;
  color: #FB3951;
  margin-left: 20px;
}

.changes-text {
  padding-left: 5px;
}

.btn-wrapper-b {
  display: flex;
}

@media all and (max-width: 1670px) {
  .translate-wrapper {
    padding-right: 300px;
  }
}

@media all and (max-width: 1460px) {
  .translate-wrapper {
    padding-right: 200px;
  }
}

@media all and (max-width: 1300px) {
  .translate-wrapper {
    padding-right: 100px;
  }
}
</style>
